// extracted by mini-css-extract-plugin
export default {"statsMessage":"StatsMessage_statsMessage__eR2rS"};